import { createRouter, createWebHistory } from 'vue-router'
import WelcomeHome from '@/views/WelcomeHome.vue'
import ImpressumSite from '@/views/ImpressumSite.vue'
import DatenschutzSite from '@/views/DatenschutzSite.vue'
import Login from '@/views/Login.vue'
import Portfolio from '@/views/Portfolio.vue'
import { verifyAuth } from '@/apiService' // <-- NEU

const routes = [
  { path: '/', name: 'Home', component: WelcomeHome },
  { path: '/login', name: 'Login', component: Login },
  { path: '/portfolio', name: 'Portfolio', component: Portfolio },
  {
    path: '/portfolio/:id',
    name: 'ProjectViewer',
    component: () => import('@/views/ProjectViewer.vue'),
    meta: { requiresAuth: true }
  },
  { path: '/impressum', name: 'Impressum', component: ImpressumSite },
  { path: '/datenschutz', name: 'Datenschutz', component: DatenschutzSite },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// --- einfacher Cache, um verify nicht bei jeder Navigation zu spammen
let authCache = { checked: false, ok: false }

async function isAuthenticated() {
  if (authCache.checked) return authCache.ok
  const ok = await verifyAuth()
  authCache = { checked: true, ok }
  return ok
}

window.addEventListener('storage', (e) => {
  if (e.key === 'access' || e.key === 'refresh') {
    authCache = { checked: false, ok: false }
  }
})

router.beforeEach(async (to, from, next) => {
  if (to.name === 'Login') return next()
  const needsAuth = to.matched.some(r => r.meta?.requiresAuth === true)
  if (!needsAuth) return next()

  const ok = await isAuthenticated()
  if (ok) return next()

  return next({ name: 'Login', query: { redirect: to.fullPath } })
})

export default router
